import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ApiErrorInterceptor } from "./api-error.interceptor";
import { ApiInterceptor } from "./api.interceptor";

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiInterceptor,
    multi: true,

  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiErrorInterceptor,
    multi: true,

  },
];
